import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MediaService from '../../services/MediaService';
import './UnitDayButton.scss';

function UnitDayButton({
  day,
  filledImageUrl,
  outlinedImageUrl,
  moduleName,
  module,
  destiny,
  influencerMessageCallback,
  unit,
  teacher,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const handleDayClick = (type, path, day) => {

    if (module.day_completed !== day - 1 && module.day_completed < day && !teacher) {
      return;
    }

    // Check for influencer ID on day 4
    if (unit > 1){
      if (module.day_completed === 4 && !(login.influencerid && login.influencerid1 && login.influencerid2 && login.influencerid3 && login.influencerid4)) {
        influencerMessageCallback();
        return;
      }
    }
    else{
      if (module.day_completed === 4 && !login.influencerid) {
        influencerMessageCallback();
        return;
      }
    }

    if (module.day_completed === day) {
      dispatch({ type: `${type}_SET_KEY`, payload: 0 });
    }

    dispatch({ type: `${type}_SET_DAY`, payload: day });
    navigate(path);
  };

  const filledImage = MediaService.getImage(filledImageUrl, login);
  const outlinedImage = MediaService.getImage(outlinedImageUrl, login);

  return (
    <div
      className={`day day--${day} ${
        module.day_completed !== day - 1 ? '' : teacher ? '' : 'bounce'
      } ${moduleName}`}
    >
      <button onClick={() => handleDayClick(moduleName, destiny, day)}>
        {outlinedImage.includes('Module9NavImages') ? 
        <img className="module9"
          src={teacher ? filledImage : module.day_completed >= day ? filledImage : outlinedImage}
          alt={`Day ${day}`}
        /> :
        <img className="modules"
          src={teacher ? filledImage : module.day_completed >= day ? filledImage : outlinedImage}
          alt={`Day ${day}`}
        />}
        <span>Day {day}</span>
      </button>
    </div>
  );
}

export default UnitDayButton;
